module.exports = __webpack_public_path__ + "media/images/cureus-siq-banner-300x250-e8f758eaac76c0b41ff02065e1bf8e65.png";